import React from "react"
import t from "theme"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import CompanyWithIcon from "./CompanyWithIcon"
import DateLabel from "./DateLabel"
import Divider from "./Divider"

const ContentDecoration = ({ type, company, date, homepage, size = t.font.size[3], ...props }) => {
    //article type and company logo if article is linked to a company; just the article type otherwise
    //Three types:
    /* 
    regular articles: type + company
    homepage sidebar: company + date
    company sidebar: type + date
*/

    const DecoCompany = () => (
        <CompanyWithIcon
            company={company}
            size={size}
            css={css`
                font-weight: ${t.font.weight.semibold};
            `}
        />
    )

    const Container = styled("div")`
        display: flex;
        align-items: center;
    `

    const TypeLabel = styled("div")`
        font-weight: ${t.font.weight.semibold};
        letter-spacing: calc(${size} * 0.05);

        font-size: ${size};
        text-transform: uppercase;
        color: ${props => (props.colored ? t.color.primary : t.color.regtext)};
    `

    const DecoDate = () => <DateLabel date={date} size={size} />

    const DecoDivider = () => <Divider direction="V" size={`calc(${size} * 1.6)`} space={`calc(${size} * 0.85)`} />

    if (homepage) {
        if (company) {
            return (
                <Container>
                    <DecoCompany />
                    <DecoDivider />
                    <DecoDate />
                </Container>
            )
        } else {
            return (
                <Container>
                    <TypeLabel>{type}</TypeLabel>
                    <DecoDivider />
                    <DecoDate />
                </Container>
            )
        }
    }

    if (type && date) {
        return (
            <Container>
                <TypeLabel>{type}</TypeLabel>
                <DecoDivider />
                <DecoDate />
            </Container>
        )
    }

    if (type && company) {
        return (
            <Container>
                <TypeLabel colored>{type}</TypeLabel>
                <DecoDivider />
                <DecoCompany />
            </Container>
        )
    }

    if (type) {
        return (
            <Container>
                <TypeLabel colored>{type}</TypeLabel>
            </Container>
        )
    }
}

export default ContentDecoration
